
/**
 * GSAP
 */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


let svgCircles = document.querySelectorAll("svg>circle");
if (svgCircles) {
    svgCircles.forEach(circle => {
        animateElasticOut(circle);
    });
};

let images = document.querySelectorAll("img.circle-img");
if (images) {
    images.forEach(img => {
        animateElasticOut(img);
    });
};

let heroText = document.querySelectorAll(".ht");
if (heroText) {
    animateHeroText();
};

function animateHeroText() {
    // console.log(txt.id);
    let tl = gsap.timeline({ repeat: -1, duration: 1, ease: "back", });
    tl.from('#first', { x: 50, opacity: 0, })
        .to("#first", { x: 50, opacity: 0, delay: 1, });
    tl.from("#second", { y: 50, opacity: 0, })
        .to("#second", { y: 50, opacity: 0, delay: 2, });
    tl.from("#third", { x: -50, opacity: 0, })
        .to("#third", { x: -50, opacity: 0, delay: 3, });
};

function animateElasticOut(circle) {
    let cn = circle.classList.value;
    let cnRep = cn.replace(/ /g, ".");

    gsap.from(`.${cnRep}`, {
        scrollTrigger: {
            trigger: `.${cnRep}`,
            start: "top bottom",
            markers: false,
            // end: "+=100px",
            // transformOrigin: "50% 50%",
            /**
             * toggleActions - Determines how the linked animation is controlled at the 4 distinct toggle places - 
             * onEnter, onLeave, onEnterBack, and onLeaveBack
             * "play", "pause", "resume", "reset", "restart", "complete", "reverse", and "none".
            */
            toggleActions: "play pause resume reset",
        },
        scale: 0,
        duration: 1,
        ease: 'elastic.out(1, 0.75)',
        delay: .65,
    });

};